import { BrowserModule ,HammerModule} from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { LayoutModule } from "@progress/kendo-angular-layout";

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from  'ngx-toastr'
import { PopupModule } from '@progress/kendo-angular-popup';
import { TreeViewModule } from '@progress/kendo-angular-treeview';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { PipesModule } from './shared/pipes/pipes.module';
import {
  PDFService,
  ExcelService,
  SuspendService,
  PDFModule,
  ExcelModule,
  GridModule,
} from '@progress/kendo-angular-grid';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { MenuModule } from '@progress/kendo-angular-menu';
import { CoreModule } from './core/core.module';
import { WindowModule, DialogsModule } from '@progress/kendo-angular-dialog';
import { NgbModalModule, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LoaderModule } from './core/loader/loader.module';
import {
  DialogService,
  DialogContainerService,
} from '@progress/kendo-angular-dialog';
import { EditInputComponent } from './shared/components/edit-input/edit-input.component';
import { AutofocusDirective } from './shared/components/edit-input/autofocus.directive';
import { LoaderService } from './core/loader/loader.service';
import { L10N_PREFIX, LocalizationService } from '@progress/kendo-angular-l10n';
import { TooltipModule, TooltipsModule } from '@progress/kendo-angular-tooltip';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { BarcodesModule } from '@progress/kendo-angular-barcodes';
import { MentionModule } from 'angular-mentions';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { EditorModule } from '@progress/kendo-angular-editor';
import { ExcelExportModule } from '@progress/kendo-angular-excel-export';
import { IconSettingsService, IconsModule } from '@progress/kendo-angular-icons';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { PagerModule } from '@progress/kendo-angular-pager';
import { PDFExportModule } from '@progress/kendo-angular-pdf-export';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { SortableModule } from '@progress/kendo-angular-sortable';
import { ToolBarModule } from '@progress/kendo-angular-toolbar';
import { UploadsModule } from '@progress/kendo-angular-upload';












// import { NgxImageCompressService } from 'ngx-image-compress';



@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    LayoutModule,
    ToastrModule.forRoot({
      positionClass: 'toast-top-center',
      preventDuplicates: true,
      maxOpened: 1,
      timeOut: 1000,
      autoDismiss: true
    }),
    BrowserAnimationsModule,
    LoaderModule,
    BrowserModule,
    BrowserAnimationsModule,
    CoreModule,
    AppRoutingModule,
    NgbModalModule,
    PopupModule,
    WindowModule,
    TreeViewModule,
    HammerModule,
    DateInputsModule,
    PipesModule,
    ExcelModule,
    PDFModule,
    NgxPaginationModule,
    NgxSmartModalModule.forRoot(),
    MenuModule,
    TooltipModule,
    MentionModule,
    IndicatorsModule,
    BarcodesModule,
    ButtonsModule,
    DialogsModule,
    DropDownsModule,
    EditorModule,
    GridModule,
    ExcelExportModule,
    IconsModule,
    ListViewModule,
    PagerModule,
    PDFExportModule,
    ProgressBarModule,
    SortableModule,
    ToolBarModule,
    TooltipsModule,
    UploadsModule
  ], schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
 
  providers: [DialogService,DialogContainerService , LoaderService,  LocalizationService, ExcelService,
    { provide: L10N_PREFIX, useValue: '' },
      {
        provide: "Window",
        useValue: window
      }
    ],
  bootstrap: [AppComponent]
})
export class AppModule {}
